import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {push} from "connected-react-router";
import PropTypes from "prop-types";
import Department from "./Department";
import Children from "./Children";
import HorizontalScroll from "../HorizontalScroll";
import withErrorBoundary from "../../decorators/withErrorBoundary";
import withMobileContext from "../../decorators/withMobileContext";
import withProductsContext from "../../decorators/withProductsContext";
import {productSelector, conditionSelector} from "../../selectors";
import {toggleProducts} from "../../AC/toggle-products";
import {changeProduct} from "../../AC/change-product";

class Products extends PureComponent {
  static propTypes = {
    isMobile: PropTypes.bool,
    products: PropTypes.array,
    product: PropTypes.object,
    condition: PropTypes.object,
    changeProduct: PropTypes.func,
    toggleProducts: PropTypes.func,
    push: PropTypes.func
  };

  state = {
    activeDepartment: this.getActiveDepartment(),
  };

  changeProduct = (productName) => {
    return (e) => {
      e.preventDefault();
      const url = e.currentTarget.attributes.href.value;
      this.props.changeProduct(productName);
      this.props.push(url);
      if (this.props.isMobile) {
        this.props.toggleProducts(false);
      }
    };
  };

  changeDepartment = (department) => {
    return () => {
      this.setState({
        activeDepartment: department
      });
    };
  };

  getActiveDepartment() {
    return this.props.products.reduce((acc, department) => {
      return {...acc, ...this.hasActiveItem(department)};
    }, {});
  }

  hasActiveItem(department) {
    return department.children.filter(
      (i) => i.product === this.props.condition.product
    ).length
      ? department
      : ``;
  }

  render() {
    const {products, isMobile, condition, product} = this.props;
    const activeItem = {
      productName: condition.product,
      id: product.id,
      rawParentId: product.raw_parent_id
    };
    const {activeDepartment} = this.state;
    return (
      <div
        className="other-products"
      >
        {isMobile ? (
          products &&
          products.map((department) => {
            return (
              <Department
                key={department.title}
                department={department}
                activeItem={activeItem}
                active={department.title === activeDepartment.title}
                changeDepartment={this.changeDepartment}
                isMobile={isMobile}
                changeProduct={this.changeProduct}
              />
            );
          })
        ) : (
          <React.Fragment>
            <div className="other-products__header">
              {products.map((department) => {
                return (
                  <Department
                    key={department.title}
                    department={department}
                    active={department.title === activeDepartment.title}
                    changeDepartment={this.changeDepartment}
                    isMobile={isMobile}
                    minimized={false}
                  />
                );
              })}
            </div>
            <div className="other-products__content">
              <HorizontalScroll>
                <Children
                  activeItem={activeItem}
                  items={activeDepartment.children}
                  changeProduct={this.changeProduct}
                  minimized={false}
                />
              </HorizontalScroll>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default connect(
  (state) => ({
    product: productSelector(state),
    condition: conditionSelector(state)
  }),
  {
    push,
    toggleProducts,
    changeProduct
  }
)(withErrorBoundary(withMobileContext(withProductsContext(Products))));
